module.exports = __webpack_public_path__ + "front/img/3.1d08b5b7.png";